import { State } from './types';

export const paymentState: State = {
  cardDeleted: '',
  forterToken: '',
};
